import { render, staticRenderFns } from "./CompanyBrForm.vue?vue&type=template&id=6f47eb63&"
import script from "./CompanyBrForm.vue?vue&type=script&lang=js&"
export * from "./CompanyBrForm.vue?vue&type=script&lang=js&"
import style0 from "./CompanyBrForm.vue?vue&type=style&index=0&id=6f47eb63&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports